import React from 'react';
import { Route, Routes } from 'react-router-dom';
import NotFound from './containers/not-found/not-found.container';
import Login from './containers/admin/login/login.container';
import ResetPassword from './containers/admin/reset-password/reset-password.container';
import ApplicationsContainer from './containers/admin/applications/applications.container';
import UnauthenticatedRoute from './components/unauthenticated-route/unauthenticated-route';
import AuthenticatedRoute from './components/authenticated-route/authenticated-route';
import PermissionRoute from './components/permission-route/permission-route';
import { Permission } from './models/role.model';
import Dealer from './containers/admin/dealers/dealer.container';
import DealersV2Container from './containers/admin/dealers-v2/dealers-v2.container';
import DealerV2FormContainer from './containers/admin/dealers-v2/dealer-v2-form.container';
import DealerFormContainer from './containers/admin/dealer-form/dealer-form.container';
import ApplicationFormController from './containers/admin/application-form/application-form';
import PaymentsContainer from './containers/admin/payments/payments.container';
import PaymentFormContainer from './containers/admin/payment-form/payment-form.container';
import DealerDocumentsContainer from './containers/admin/dealer-documents/dealer-documents.container';
import DealerDocumentFormContainer from './containers/admin/dealer-document-form/dealer-document-form.container';
import ServiceFormContainer from './containers/credit-application/credit-application.component';
import InlineServiceFormPage from './containers/partner-service-form/partner-service-form.component';
import Embed from './containers/embed/embed.container';
import EmbedMazo from './containers/embed-mazo/embed-mazo.container';
import DashboardContainer from './containers/admin/dashboard/dashboard.container';
import CommercialFormsContainer from './containers/admin/commercial-forms/commercial-forms.container';
import DealerProspectsContainer from './containers/admin/dealer-prospects/dealer-prospects.container';
import DealerProspectFormContainer from './containers/admin/dealer-prospect/dealer-prospect-form.container';
import MyLeadsContainer from './containers/admin/my-leads/my-leads.container';
import CommercialFormController from './containers/admin/commercial-form/commercial-form';
import DocumentsContainer from './containers/admin/documents/documents.container';
import DocumentFormContainer from './containers/admin/documents/document-form.container';
import NewsContainer from './containers/admin/news/news.container';
import NewsFormContainer from './containers/admin/news/news-form.container';
import UsersContainer from './containers/admin/users/users.container';
import UserFormContainer from './containers/admin/users/user-form.container';
import AnalyticReportContainer from './containers/admin/analytic-report/analytic-report.container';
import ProfileContainer from './containers/admin/profile/profile.container';
import QuotesContainer from './containers/admin/quotes/quotes.container';
import QuoteFormContainer from './containers/admin/quote-form/quote-form.container';
import FeesContainer from './containers/admin/fees/fees.container';
import AdminDocsContainer from './containers/admin/admin-docs/admin-docs.container';
import AdminDocFormContainer from './containers/admin/admin-docs/admin-doc-form.container';
import OnboardingContainer from './containers/admin/onboarding/onboarding.container';
import ContractingContainer from './containers/admin/contracting/contracting.container';
import ContractingViewContainer from './containers/admin/contracting/contracting-view.container';
import ContractingPage from './containers/contracting/contracting-page.container';
import AffiliationFormContainer from './containers/affiliation-form/affiliation-form.container';
import TestPage from './containers/test-page/test-page';

import { LeadSource } from './models/application.model';

export default function Links() {
  return (
    <Routes>
      <Route path="/affiliation-form/:dealerId?" element={<AffiliationFormContainer />} />
      <Route
        path="/contracting/:opportunityId?/:dealerName?/:analystEmail?"
        element={
          <UnauthenticatedRoute>
            <ContractingPage />
          </UnauthenticatedRoute>
        }
      />
      <Route path="/test-page" element={<TestPage />} />
      <Route path="/embed" element={<Embed />} />
      <Route path="/embed-mazo" element={<EmbedMazo />} />
      <Route path="/embed/id/:dealerId/:dealerLocation?/:dealerStock?" element={<Embed />} />
      <Route
        path="/"
        element={
          <UnauthenticatedRoute>
            <ServiceFormContainer leadSource={LeadSource.WEBSITE} />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/id/:dealerId/:dealerLocation?/:dealerStock?"
        element={
          <UnauthenticatedRoute>
            <ServiceFormContainer leadSource={LeadSource.WEBSITE} />
          </UnauthenticatedRoute>
        }
      />
      {/* ANALYTICS ROUTES */}
      {/* NEW LEAD ROUTES */}
      <Route
        path="/nl/:analyticName"
        element={
          <UnauthenticatedRoute>
            <ServiceFormContainer leadSource={LeadSource.WEBSITE} />
          </UnauthenticatedRoute>
        }
      />
      {/* Co-Buyer ROUTES */}
      <Route
        path="/cb/:analyticName"
        element={
          <UnauthenticatedRoute>
            <ServiceFormContainer leadSource={LeadSource.WEBSITE} />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/partner-service-form"
        element={
          <UnauthenticatedRoute>
            <InlineServiceFormPage leadSource={LeadSource.WEBSITE} />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/phone/partner-service-form"
        element={
          <AuthenticatedRoute>
            <InlineServiceFormPage leadSource={LeadSource.PHONE} />
          </AuthenticatedRoute>
        }
      />
      {/* ADMIN ROUTES */}
      <Route
        path="/dashboard"
        element={
          <AuthenticatedRoute>
            <DashboardContainer />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/onboarding"
        element={
          <AuthenticatedRoute>
            <OnboardingContainer />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <AuthenticatedRoute>
            <ProfileContainer />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/phone"
        element={
          <AuthenticatedRoute>
            <ServiceFormContainer leadSource={LeadSource.PHONE} />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/login"
        element={
          <UnauthenticatedRoute>
            <Login />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/reset-password"
        element={
          <UnauthenticatedRoute>
            <ResetPassword />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/service-forms"
        element={
          <AuthenticatedRoute>
            <ApplicationsContainer />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/service-forms/:applicationId"
        element={
          <AuthenticatedRoute>
            <ApplicationFormController />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/commercial-forms"
        element={
          <AuthenticatedRoute>
            <CommercialFormsContainer />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/commercial-forms/:applicationId"
        element={
          <AuthenticatedRoute>
            <CommercialFormController />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/dealers"
        element={
          <AuthenticatedRoute>
            <Dealer />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/dealers/:dealerId"
        element={
          <AuthenticatedRoute>
            <DealerFormContainer />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/dealers-v2"
        element={
          <PermissionRoute permission={Permission.MANAGE_DEALERS_V2}>
            <DealersV2Container />
          </PermissionRoute>
        }
      />
      <Route
        path="/dealers-v2/new"
        element={
          <PermissionRoute permission={Permission.MANAGE_DEALERS_V2}>
            <DealerV2FormContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/dealer-prospects"
        element={
          <PermissionRoute permission={Permission.MANAGE_DEALER_PROSPECTS}>
            <DealerProspectsContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/dealer-prospects/:prospectId"
        element={
          <PermissionRoute permission={Permission.MANAGE_DEALER_PROSPECTS}>
            <DealerProspectFormContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/my-leads"
        element={
          <PermissionRoute permission={Permission.MANAGE_MY_LEADS}>
            <MyLeadsContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/payments"
        element={
          <PermissionRoute permission={Permission.SERVICE_PAY}>
            <PaymentsContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/payments/:paymentId"
        element={
          <PermissionRoute permission={Permission.SERVICE_PAY}>
            <PaymentFormContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/admin-contracting"
        element={
          <PermissionRoute permission={Permission.CONTRACTING}>
            <ContractingContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/admin-contracting/:contractingId"
        element={
          <PermissionRoute permission={Permission.CONTRACTING}>
            <ContractingViewContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/quotes"
        element={
          <PermissionRoute permission={Permission.MANAGE_QUOTES}>
            <QuotesContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/quotes/:quoteId"
        element={
          <PermissionRoute permission={Permission.MANAGE_QUOTES}>
            <QuoteFormContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/fees"
        element={
          <PermissionRoute permission={Permission.MANAGE_FEES}>
            <FeesContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/dealer-documents"
        element={
          <PermissionRoute permission={Permission.DEALER_REGISTRATION_DOCS}>
            <DealerDocumentsContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/dealer-documents/:dealerDocumentId"
        element={
          <PermissionRoute permission={Permission.DEALER_REGISTRATION_DOCS}>
            <DealerDocumentFormContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/admin-docs"
        element={
          <PermissionRoute permission={Permission.MANAGE_ADMIN_DOCS}>
            <AdminDocsContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/admin-docs/:adminDocId"
        element={
          <PermissionRoute permission={Permission.MANAGE_ADMIN_DOCS}>
            <AdminDocFormContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/analytic-report"
        element={
          <PermissionRoute permission={Permission.VIEW_ANALYTIC_REPORT}>
            <AnalyticReportContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/documents"
        element={
          <PermissionRoute permission={Permission.MANAGE_DOCUMENTS}>
            <DocumentsContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/documents/:documentId"
        element={
          <PermissionRoute permission={Permission.MANAGE_DOCUMENTS}>
            <DocumentFormContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/news"
        element={
          <PermissionRoute permission={Permission.MANAGE_NEWS}>
            <NewsContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/news/:newsId"
        element={
          <PermissionRoute permission={Permission.MANAGE_NEWS}>
            <NewsFormContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/users"
        element={
          <PermissionRoute permission={Permission.MANAGE_USERS}>
            <UsersContainer />
          </PermissionRoute>
        }
      />
      <Route
        path="/users/:username"
        element={
          <PermissionRoute permission={Permission.MANAGE_USERS}>
            <UserFormContainer />
          </PermissionRoute>
        }
      />
      {/* Finally, catch all unmatched routes */}
      <Route path="*" element={<NotFound />} />;
    </Routes>
  );
}
